import { RESET_LANGUAGE, SET_LANGUAGE } from "../types"

export const setLanguage = (language) => {
    return {
        type: SET_LANGUAGE,
        payload: language,
    }
}

export const resetLanguage = () => {
    return {
        type: RESET_LANGUAGE,
    }
}
